<template>
    <div>
        <div class="flex justify-end">
            <Search :placeholder="$t('商品名称')" @search="search"></Search>
        </div>

        <div class="classifies space-x-4 mt-3 text-left">
            <span v-for="classify in classifies" :key="classify.id" class="cursor-pointer"
                :class="{ 'text-main': curClassifyId == classify.id }" @click="setClassify(classify.id)">{{
                    classify.name }}</span>
        </div>
        <div class="w-full grid grid-cols-[auto,34.31rem] gap-3">
            <div class="left">
                <div class="products text-left" v-if="productPager.total">
                    <div class="product" v-for="item in productPager.items" :key="item.id">
                        <img :src="$firstImage(item.images, 'small')">
                        <span class="font-semibold">{{ item.name }}</span>
                        <div class="space-x-4">
                            <template v-if="item.complete_attrs">
                                <span>{{ item.complete_attrs.color }}</span>
                                <span>{{ item.complete_attrs.level || '' }}</span>
                                <span>{{ item.complete_attrs.norm || '' }}</span>
                                <span>{{ item.complete_attrs.maturity || '' }}</span>
                                <span>{{ item.complete_attrs.length || '' }}</span>
                            </template>
                        </div>
                        <div class="space-x-4">
                            <span>{{ $t('库存') }}：{{ item.stock }}</span>
                            <span>{{ $t('销量') }}：{{ changeval(item.sales) }}</span>
                        </div>
                        <div class="flex-between">
                            <span class="text-yellow-600">{{ $p(item.price) }}</span>
                            <el-input-number v-model="item.quantity" :min="0" :max="item.stock" size="mini"
                                :disabled="item.stock <= 0" @change="selectProduct(item, $event)"></el-input-number>
                        </div>
                    </div>
                </div>
                <div v-else class="mt-6">
                    <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
                </div>
                <div class="text-center mt-4" v-if="productPager.total">
                    <el-pagination :page-size="productPager.size" layout="prev, pager, next" :total="productPager.total"
                        @current-change="pageChange">
                    </el-pagination>
                </div>
            </div>
            <div class="relative right" ref="orderBlank">
                <div class="bg-white" ref="boxFixed">
                    <p class="bg-main text-white text-xl h-3rem leading-3rem">{{ $t('选择商品') }}</p>
                    <div class="text-left text-0.88rem p-5">
                        <div class="max-h-70vh overflow-y-auto overflow-x-hidden" ref="scroll">
                            <table class="w-full text-center  relative" ref="scrollChild">
                                <tr>
                                    <th>{{ $t('名称') }}</th>
                                    <th>{{ $t('数量') }}</th>
                                    <th>{{ $t('均价') }}</th>
                                    <th>{{ $t('库存') }}</th>
                                    <th>{{ $t('删除') }}</th>
                                </tr>
                                <tr v-for="(item, index) in selectedProducts" :key="item.id" :class="{
                                    shakex: isActive == item.id,
                                    shelves: item.stock <= 0
                                }">
                                    <td>{{ item.name }}</td>

                                    <td class="w-7rem">
                                        <el-input-number v-model="item.quantity" :min="0" :max="item.stock" size="mini"
                                            class="w-6rem" @change="selectProduct(item, $event)"></el-input-number>

                                    </td>
                                    <td>{{ item.price }}</td>
                                    <td class="text-hex-EA4335">{{ item.stock }}</td>
                                    <td @click="delProduct(index)">
                                        <span class="iconfont icon-shanchu text-hex-909090 cursor-pointer"></span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="flex-between mt-5">
                            <div>{{ $t('已选') }}<span class="text-main">{{ selectedProducts.length }}</span>{{ $t('品种') }}
                            </div>
                            <el-button type="danger" class="px-12 py-3 bg-hex-F20000  cursor-pointer"
                                @click="confirmProduct">{{
                                $t('确定') }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, computed, watch, onMounted } from "@vue/composition-api";
import Search from "@/components/mine/search.vue";

export default {
    components:{Search},
    setup(props, ctx) {
        // start 商品分类
        const curClassifyId = ref('all')
        const classifies = ref([])
        const getClassifies = async () => {
            ctx.root.$doing()
            let res = await ctx.root.$callapi('pre/getClassifyList', {
                wh: "origin",
                tag: 'syj',
            })
            ctx.root.$done()
            if (res.code == 0 && res.data?.items) {
                classifies.value = res.data.items
                classifies.value.unshift({
                    id: 'all',
                    name: ctx.root.$t('全部')
                })
            }
        }
        const setClassify = (id) => {
            curClassifyId.value = id
            productPager.value.first()
        }
        // end


        const productPager = ref(
            new ctx.root.$Pager({
                apiname: 'getProductList',
                size: 15,
                param: () => ({
                    tag: 'syj',
                    wh: 'origin',
                    q__name__icontains: keyword.value,
                    q__pproduct__classify_id: curClassifyId.value == 'all' ? '' : curClassifyId.value
                })
            })
        )
        const pageChange = async (page) => {
            await productPager.value.load(page)
        }


        onMounted(() => {
            getClassifies()
            productPager.value.first()
        })
        // start 选择商品
        const isActive = ref(null)
        const selectedProducts = ref([])
        const selectProduct = (item, e) => {

            let index = selectedProducts.value.findIndex(product => product.id == item.id)
            if (index == -1) {
                if (e) {
                    selectedProducts.value.push(item)
                    scrollToBottom();
                }
            } else {
                if (!e) {
                    selectedProducts.value.splice(index, 1)
                } else {
                    selectedProducts.value[index].quantity = e
                }
            }
            if (scroll.value) {
                scroll.value.scrollTo({
                    top: scrollChild.value?.children[index + 1].offsetTop - scroll.value?.clientHeight + scrollChild.value?.children[index + 1].clientHeight,
                    behavior: 'smooth'
                })
            }
            isActive.value = item.id;
            setTimeout(() => {
                isActive.value = "";
            }, 600);
        }

        const confirmProduct = async () => {
            ctx.emit('confirmProduct', selectedProducts.value)
        }
        const delProduct = (index) => {
            selectedProducts.value[index].quantity = 0
            selectedProducts.value.splice(index)
        }


        // start 处理销量展示
        const changeval = (v) => {
            if (v > 10000) {
                return (v / 10000).toFixed(1) + '万'
            }
            return v
        }
        // end

        //  滚动
        const scroll = ref(
            ctx.refs.scroll
        )
        const scrollChild = ref(ctx.refs.scrollChild
        )
        // 新增滚动到底部方法
        const scrollToBottom = () => {
            ctx.root.$nextTick(() => {
                if (scroll.value) {
                    scroll.value.scrollTo({
                        top: scroll.value.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            });
        };
         // start 搜索
        const keyword = ref('')
        const search = (e) => {
            keyword.value = e
            productPager.value.first()
        }
        // end

        return {
            productPager,
            pageChange,
            curClassifyId,
            setClassify,
            classifies,
            confirmProduct,
            selectedProducts,
            selectProduct,
            delProduct,
            changeval,
            isActive,
            scroll,
            scrollChild,
            scrollToBottom,
            search
        };
    },
}
</script>
<style scoped lang="scss">.products {
  display: -ms-grid;
  display: grid;
  margin-top: 1rem;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}
.products .product {
  display: -ms-grid;
  display: grid;
  width: 100%;
  grid-template-columns: 6rem auto;
  grid-column-gap: 0.4rem;
  border: 1px solid #eeeeee;
  padding: 0.4rem;
}
.products .product img {
  grid-row: 1/5;
}
@keyframes shakeX {
  .right 0%, .right 100% {
    transform: translateX(0);
  }
  .right 25% {
    transform: translateX(-5px);
  }
  .right 50% {
    transform: translateX(5px);
  }
  .right 75% {
    transform: translateX(-5px);
  }
}
.right .shakex {
  animation: shakeX 0.5s ease-in-out infinite;
}
.right table, .right td, .right th {
  border-width: 1px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.right th {
  font-weight: 600;
  height: 2.5rem;
}
.right td {
  height: 3.25rem;
}
.right .title {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  font-weight: 600;
  height: 1.94rem;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.right .is_fixed_top {
  position: fixed;
  top: 3rem;
  width: 34rem;
  z-index: 9;
}
.right .is_fixed_bottom {
  position: fixed;
  bottom: 17rem;
  width: 34rem;
  z-index: 9;
}
.right .shelves {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
.right .paddingTop {
  padding-top: 0.75rem;
}</style>